import {cn} from '@common-web/lib/utils';

// Hover text for controls that carry a PreviewDot.
export const NOT_BUILT = 'Not built yet';

// Marks a control whose action isn't built yet. Search for PreviewDot to find them all.
// The control needs `relative` positioning; `inline` places the dot at the end of a menu item.
export function PreviewDot({inline}: {inline?: boolean}) {
  return (
    <span
      aria-hidden
      className={cn(
        'h-2 w-2 shrink-0 rounded-full bg-amber-400',
        inline ? 'ml-auto' : 'pointer-events-none absolute -right-1 -top-1 ring-2 ring-white',
      )}
    />
  );
}
